import { css } from '@emotion/css'
import {
  breakpoint,
  colors,
  fontSize,
  fontWeight,
  mediaQueryHelper,
  shorthandHelper,
  spacing,
} from '@offerzen/pinata-shame'

const styles = {
  container: css({
    marginTop: spacing.extraLarge,
    marginBottom: spacing.large,
    display: 'grid',
    gridTemplateColumns: '262px 1fr',

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      display: 'flex',
    },
  }),

  content: css({
    color: colors.blackPearl,
    padding: shorthandHelper([spacing.extraLarge, spacing.large]),
    background: colors.white,
    width: '100%',
  }),

  nav: css({
    position: 'sticky',
    fontSize: fontSize.medium,
    background: colors.athensGray,

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      display: 'none',
    },

    ul: {
      paddingLeft: spacing.medium,
      margin: 0,
      width: '100%',
      maxWidth: 262,
      bottom: 0,
      top: 0,
    },

    '> ul': {
      position: 'sticky',
      paddingTop: spacing.medium,
    },

    li: {
      listStyle: 'none',
    },

    'li:last-child': {
      marginBottom: spacing.small,
    },

    a: {
      marginBottom: spacing.medium,
      display: 'inline-block',
    },
  }),

  heading: dataLevel => {
    let fontWeightValue = ''

    switch (dataLevel) {
    case '0':
      fontWeightValue = fontWeight.semiBold
      break
    case '1':
      fontWeightValue = fontWeight.medium
      break
    default:
      fontWeightValue = fontWeight.regular
      break
    }

    return css({
      textDecoration: 'none',
      color: colors.blackPearl,
      fontWeight: fontWeightValue,
    })
  },
}

export default styles
